<template>
  <header class="lg:hidden">
    <div class="flex items-center gap-3 px-4 pt-5 pb-2">
      <!-- Logo -->
      <router-link to="/dashboard" class="flex-none">
        <img src="/reeltrack-orange.svg" alt="ReelTrack" class="h-10" />
      </router-link>

      <!-- Actions -->
      <div class="ml-auto flex items-center gap-2">
        <!-- h-11/w-11 keeps these on the 44px minimum touch target. -->
        <button
          type="button"
          class="flex h-11 w-11 items-center justify-center rounded-md text-muted hover:text-highlight"
          :aria-label="$t('search')"
          :aria-expanded="searchOpen ? 'true' : 'false'"
          aria-controls="mobile-search"
          @click="toggleSearch"
        >
          <Font-awesome-icon
            :icon="['fas', searchOpen ? 'xmark' : 'search']"
            size="lg"
          />
        </button>

        <button
          type="button"
          class="relative flex h-11 w-11 items-center justify-center rounded-md text-muted hover:text-highlight"
          :aria-label="$t('notifications')"
        >
          <Font-awesome-icon :icon="['far', 'bell']" size="lg" />
          <span
            v-if="notifications > 0"
            class="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-highlight text-primary-700 text-[10px] font-semibold"
          >
            {{ notifications }}
          </span>
        </button>

        <!-- Avatar menu: profile, settings, sign out -->
        <UserMenu size="sm" />
      </div>
    </div>

    <!-- Expandable search -->
    <form
      v-if="searchOpen"
      id="mobile-search"
      class="px-4 pb-3"
      role="search"
      autocomplete="off"
      @submit.prevent="submitSearch"
      @keydown.esc="closeSearch"
    >
      <div class="relative">
        <input
          ref="searchInput"
          v-model="query"
          type="search"
          name="search"
          :aria-label="$t('search')"
          :placeholder="$t('search')"
          class="w-full rounded-md bg-primary-500 text-white border border-primary-400 placeholder:text-subtle placeholder:opacity-60 py-3 pl-4 pr-12 focus:border-highlight focus:ring-1 focus:ring-highlight"
        />
        <button
          type="submit"
          class="absolute inset-y-0 right-0 flex items-center pr-4 text-muted hover:text-highlight"
          :aria-label="$t('search')"
        >
          <Font-awesome-icon :icon="['fas', 'search']" />
        </button>
      </div>
    </form>
  </header>
</template>

<script>
import { ViewName } from "@/router";
import UserMenu from "@/components/navigation/UserMenu.vue";

export default {
  name: "MobileTopbar",
  components: { UserMenu },

  data() {
    return {
      query: "",
      searchOpen: false,
      // No notifications backend yet; badge shows only when > 0.
      notifications: 0,
    };
  },

  methods: {
    toggleSearch() {
      this.searchOpen = !this.searchOpen;
      if (this.searchOpen) {
        this.$nextTick(() => this.$refs.searchInput?.focus());
      }
    },
    // Escape is the expected way out of an expanded search field.
    closeSearch() {
      this.searchOpen = false;
    },
    submitSearch() {
      const q = this.query.trim();
      if (!q) return;
      this.searchOpen = false;
      this.$router
        .push({ name: ViewName.Explore, query: { q } })
        .catch(() => undefined);
    },
  },
};
</script>
